import { Component, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Model } from '../../../model/api/assets/model';
import { GenericDetail } from '../../generic/generic.detail';

@Component({
    selector: 'model-detail',
    templateUrl: 'model.detail.html'
})
export class ModelDetail extends GenericDetail<Model, number> {

    @ViewChild('detailForm') detailForm: FormGroup;

    setItemDefaultValues() {
        this.item = new Model();
    }

    public resetForm() {
        this.detailForm.reset();
    }

    public saveItem() {
        super.saveItem();
    }
}